import api from './api'

export const getWorkflowDefinition = async (productId) => {
  if (!productId) return null
  const response = await api.get(`/workflows/${productId}/definition`)
  return response.data
}

export const getConsumerWorkflowCurrentState = async (consumerId, productId) => {
  if (!consumerId) return null

  const response = await api.get(`/workflows/consumer/${consumerId}/current-state`, {
    params: productId ? { productId } : undefined,
  })

  return response.data
}

export const getConsumerWorkflowResolvers = async (consumerId, productId) => {
  if (!consumerId) return null

  const response = await api.get(`/workflows/consumer/${consumerId}/resolvers`, {
    params: productId ? { productId } : undefined,
  })

  return response.data
}
